<div class="row">
    <div class="col-lg-12 col-xl-10 offset-xl-1">



        <form [formGroup]="form" autocomplete="off" novalidate [autocomplete]="'off'" (ngSubmit)="onSubmit()">
            <h3 class="mb-3">Product range</h3>

            <div *ngIf="productRanges.length > 1" class="mb-3 text-center p-3" style="background-color: aliceblue;">
                <p>This supplier has more than one product range assigned. Please select the one you wish to proceed
                    with</p>

                <button type="button" class="btn btn-round btn-slim btn-primary me-3 "
                    [ngClass]="{'active': productRange && r.id === productRange.id}" (click)="setRange(r)"
                    *ngFor="let r of productRanges">{{r.name}}</button>
            </div>

            <div class="mb-3 row">
                <label class="col-sm-4 col-form-label">Select collection address for the range</label>
                <div class="col-sm-8">

                    <ng-select placeholder="Select collection address" class="dark">
                        <ng-option [value]="add.ID" *ngFor="let add of this.addressData"> {{add.add1}}, {{add.town}},
                            {{add.postcode}}</ng-option>
                    </ng-select>
                </div>
            </div>

            <div class="mb-3 row">
                <label class="col-sm-4 col-form-label">Range name</label>
                <div class="col-sm-8">
                    <input type="text" autocomplete="new-password" class="form-control bordered"
                        [ngClass]="{'is-invalid' : form.controls.name.invalid && form.controls.name.dirty}"
                        formControlName="name" placeholder="Range name">
                    <div class="invalid-feedback">Enter a valid name</div>
                </div>
            </div>

            <div class="mb-3 row">
                <label class="col-sm-4 col-form-label">Range URL</label>
                <div class="col-sm-8">
                    <input type="text" autocomplete="new-password" class="form-control bordered"
                        [ngClass]="{'is-invalid' : form.controls.slug.invalid && form.controls.slug.dirty}"
                        formControlName="slug" placeholder="Group URL">
                    <div class="invalid-feedback">Enter a valid URL</div>
                </div>
            </div>

            <div class="mb-3 row">
                <label class="col-sm-4 col-form-label">Preview text</label>
                <div class="col-sm-8">

                    <textarea class="form-control bordered" rows="3" formControlName="previewText"
                        placeholder="Enter banner text"></textarea>
                    <span class="form-text m-b-none">
                        Enter a short descriptive paragraph to be shown as part main page banner.
                    </span>
                </div>
            </div>

            <div class="mb-3 row">
                <label class="col-sm-4 col-form-label">Range description</label>
                <div class="col-sm-8">
                    <textarea rows="5" type="text" autocomplete="new-password" class="form-control bordered"
                        [ngClass]="{'is-invalid' : form.controls.description.invalid && form.controls.description.dirty}"
                        formControlName="description" placeholder="Range description"></textarea>
                    <div class="invalid-feedback">Description must be entered</div>
                </div>
            </div>

            <div class="mb-3 row">
                <label class="col-sm-4 col-form-label">Base cost per cubic metre</label>
                <div class="col-sm-8">
                    <input type="number" class="form-control bordered"
                        [ngClass]="{'is-invalid' : form.controls.baseCost.invalid && form.controls.baseCost.dirty}"
                        formControlName="baseCost" placeholder="Base cost">
                    <div class="invalid-feedback">Enter range base cost</div>
                </div>
            </div>


            <div class="mb-3 row">
                <label class="col-sm-4 col-form-label">Base weight per cubic metre</label>
                <div class="col-sm-8">
                    <input type="number" class="form-control bordered"
                        [ngClass]="{'is-invalid' : form.controls.baseWeight.invalid && form.controls.baseWeight.dirty}"
                        formControlName="baseWeight" placeholder="Base weight">
                    <div class="invalid-feedback">Enter range base weight</div>
                </div>
            </div>


            <div class="row">
                <div class="col-4">
                    <a (click)="togglePreviewSlider()">
                        <i class="toggle fa" [ngClass]="{
                                    'fa-toggle-on text-success': form.value.showInPreviewSlider,
                                    'fa-toggle-off' : !form.value.showInPreviewSlider}"></i>
                        Show in preview slider?
                    </a>
                </div>
                <div class="col-4">
                    <a (click)="toggleMainMenu()">
                        <i class="toggle fa" [ngClass]="{
                                    'fa-toggle-on text-success': form.value.showInMainMenu,
                                    'fa-toggle-off' : !form.value.showInMainMenu}"></i>
                        Show in main menu?
                    </a>
                </div>
                <div class="col-4">
                    <a (click)="toggleAvailable()">
                        <i class="toggle fa" [ngClass]="{
                        'fa-toggle-on text-success': form.value.available,
                        'fa-toggle-off' : !form.value.available}"></i>
                        Make live?
                    </a>
                </div>
            </div>


            <div class="p-2 bg-white mt-3">
                <div class="row">
                    <div class="col-sm-4">

                        <div *ngIf="form.value.imageUrl" class="product-image-preview border-0"
                            style="width: 100%; background-size: contain"
                            [ngStyle]="{'background-image': 'url(' + form.value.imageUrl + ')'}">
                            <a class="image-delete" (click)="deleteImage()">
                                <i class="fa fa-trash"></i>
                            </a>
                        </div>

                        <img *ngIf="!form.value.imageUrl" src="/assets/images/no-image.png" class="img-fluid" />
                    </div>
                    <div class="col-sm-8">
                        <div class="dropzone dropzone-container" *ngIf="uploadConfig" [dropzone]="uploadConfig"
                            (error)="onUploadError($event)" (uploadProgress)="uploadprogress($event)"
                            (success)="onUploadSuccess($event)">

                            <div class="dz-message" data-dz-message><span>Drag files here or click here to upload</span>
                            </div>
                            <div class="dz-details">
                                <div class="dz-filename"><span data-dz-name></span></div>
                                <div class="dz-size" data-dz-size></div>
                                <img data-dz-thumbnail />
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <div class="row">
                <div class="col-6">

                </div>
                <div class="col-6 text-end">
                    <button [disabled]="form.invalid" class="btn btn-round btn-primary mt-4" type="submit" tabindex="3">
                        Continue
                    </button>
                </div>
            </div>

            <div class="mt-2 text-end">
                <p>Product range data will be saved upon clicking 'Continue'</p>
            </div>

        </form>

    </div>
</div>